import { FilterBoolEnum } from "@app/operations/ai-response-review/enums";
import { QESSelect } from "@app/shared/qes-standards/forms/Select";
import { FC } from "react";

interface AiResponseReviewYesNoSelectProps {
  updateCallback: (value: FilterBoolEnum) => void;
  value: string;
  label: string;
  testId: string;
}

const AiResponseReviewYesNoSelect: FC<AiResponseReviewYesNoSelectProps> = ({
                                                                             updateCallback,
                                                                             value,
                                                                             label,
                                                                             testId
                                                                           }) => {
  return (
    <div className="ai-response-review-filters__item">
      <div className="ai-response-review-filters__label">{label}</div>
      <div className="ai-response-review-filters__input">
        <QESSelect
          className="mb-0"
          containerClassName="mb-0 col-12 col-xl"
          hideLabel={true}
          onChange={e => updateCallback(e.target.value as FilterBoolEnum)}
          testId={testId}
          value={value}
          label=""
        >
          <option value="all">All</option>
          <option value="yes">Yes</option>
          <option value="no">No</option>
        </QESSelect>
      </div>
    </div>
  );
}

export default AiResponseReviewYesNoSelect;